import { Component, OnInit, HostListener } from '@angular/core';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ServicepartnarpopupComponent } from '../servicepartnarpopup/servicepartnarpopup.component';
@Component({
  selector: 'app-servicepartners',
  templateUrl: './servicepartners.component.html',
  styleUrls: ['./servicepartners.component.css']
})
export class ServicepartnersComponent implements OnInit {
  dropdownVisible = false;
  dropdownIndex: number | null = null;
  dropdownPosition = { top: 0, left: 0 };
  model: { year: number, month: number, day: number };
  servicePartners = [
    {
      serviceType: 'Interior Design',
      organisationName: 'Reddot Interiors',
      contactPerson: 'K Venu Gopal',
      mobileNumber: '8796456787',
      emailId: 'kvgopal@reddot.com',
      city: 'Hyderabad',
      securityDeposit: '₹500000',
      date: '2025-05-07',
      doc: '',
    },
    {
      serviceType: 'Furnishing',
      organisationName: 'OAK furnitures',
      contactPerson: 'Rashid Ahmed',
      mobileNumber: '8745231899',
      emailId: 'rashid@oacindia.com',
      city: 'Mumbai',
      securityDeposit: '₹500000',
      date: '2025-05-07',
      doc: '',
    },
    {
      serviceType: 'Solar Systems',
      organisationName: 'Junna Solarsystems',
      contactPerson: 'Venkat Reddy',
      mobileNumber: '7873467222',
      emailId: 'info@junnarsolar.com',
      city: 'Hyderabad',
      securityDeposit: '₹500000',
      date: '2025-05-07',
      doc: '',
    },
    {
      serviceType: 'Smart Home',
      organisationName: 'Promac Smart Systems',
      contactPerson: 'AK Dubey',
      mobileNumber: '9440367228',
      emailId: 'akdubey@promac.com',
      city: 'Hyderabad',
      securityDeposit: '₹500000',
      date: '2025-05-07',
      doc: '',
    },
    {
      serviceType: 'Banker',
      organisationName: 'Axis Finance Ltd',
      contactPerson: 'Rajath Kumar',
      mobileNumber: '₹8777634545',
      emailId: 'rajath.agm@axis.in',
      city: 'Mumbai',
      securityDeposit: 'NO',
      date: '2025-05-07',
      doc: '',
    },
    {
      serviceType: 'Packers & Movers',
      organisationName: 'Logistic Mart',
      contactPerson: 'Nishith Menon',
      mobileNumber: '9978766453',
      emailId: 'nishith@logisticmart.in',
      city: 'Hyderabad',
      securityDeposit: '₹500000',
      date: '2025-05-07',
    },
    // Add more leads here...
  ];
  constructor(
    private modalService: NgbModal,
    private lookupModel: RsbLookupModel,
    private toastrService: ToastrService
  ) { }

  ngOnInit(): void {
    this.servicePartners = this.lookupModel.getServicePartners().length ?  this.lookupModel.getServicePartners(): this.servicePartners 
  }

  addServicePartner(): void {
    const modalRef = this.modalService.open(ServicepartnarpopupComponent);

    modalRef.result.then((result) => {
      const rslt = result;
      const arg = {
        serviceType: rslt.serviceType,
        organisationName: rslt.organisationName,
        contactPerson: rslt.contactPerson,
        mobileNumber: rslt.mobileNumber,
        emailId: rslt.emailId,
        city: rslt.city,
        securityDeposit: rslt.securityDeposit,
        date: rslt.date

      }

      this.servicePartners.push(arg);
      this.lookupModel.setServicePartners(this.servicePartners)
      this.toastrService.success('Service Partner added successfully');

    }, (reason) => {
      console.log('Modal dismissed:', reason);
    });
  }


  editService(row: any, index: any): void {
    const mdlRef = this.modalService.open(ServicepartnarpopupComponent);
    mdlRef.componentInstance.partnerInfo = row;
    mdlRef.result.then((rslt) => {
      if (rslt) {
        const categoryupdate = {
          serviceType: rslt.serviceType,
          organisationName: rslt.organisationName,
          contactPerson: rslt.contactPerson,
          mobileNumber: rslt.mobileNumber,
          emailId: rslt.emailId,
          city: rslt.city,
          securityDeposit: rslt.securityDeposit,
          date: rslt.date

        };
        this.servicePartners[index] =  categoryupdate
        this.lookupModel.setServicePartners(this.servicePartners);
        this.toastrService.success('Service Partner updated successfully');
      }
    })
  }



  deleteService(index: number): void {

    this.servicePartners.splice(index,1)
    this.lookupModel.setServicePartners(this.servicePartners)
    this.toastrService.success('Service Partner deleted successfully');

  }



}
